/**
 * PURCHASE MODE — the PDP buy box.
 * SITE_PAGES_SPEC.md ADDENDUM 15 (deck row 13).
 *
 * THE RULE: "a customer cannot become a subscriber by accident. Every path to
 * a recurring charge requires an affirmative act that NAMES the recurrence at
 * the moment of commitment."
 *
 * ⭐ READ THIS BEFORE CHANGING ANYTHING HERE: this file cannot break the rule.
 * It has no access to the plan id and never sets one. In `product.liquid` the
 * form contains NO `selling_plan` input — each plan id rides on its own submit
 * button's name/value, so a plan is posted only when a button whose visible
 * label states the interval is the thing that submitted the form. Everything
 * below is presentation: it decides which fully-labelled button is on screen,
 * never what gets sent.
 *
 * WHAT IT ENHANCES. Server-rendered (no-JS) the box is "Buy now" plus one
 * "Subscribe — ships every N weeks" button per plan, all visible. Correct, and
 * untidy. This collapses it into a15 ③'s two-step reveal:
 *
 *     [ Buy now ]                      ← primary, always live, submits no plan
 *     [ Subscribe & save 20% ]         ← reveals the cadence step
 *        How often should it ship?
 *        ( Every 4 weeks )( Every 8 weeks )( Every 12 weeks )   ← none preset
 *     [ Subscribe — ships every 8 weeks ]   ← appears only once one is picked
 *
 * ⚠ Nothing is preselected, ever (a15 ⑦ #2). The subscribe commit does not
 * exist on screen until the customer has chosen an interval, and the button
 * that then appears names it.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-purchase]').forEach(init);

  function init(root) {
    var open = root.querySelector('[data-purchase-open]');
    var panel = root.querySelector('[data-purchase-panel]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('[data-purchase-pick]'));
    var commits = Array.prototype.slice.call(root.querySelectorAll('[data-purchase-commit]'));

    // If the markup is not the shape we expect, leave the server-rendered box
    // exactly as it is. The no-JS shape is a correct buy box, not a fallback,
    // so bailing out costs tidiness and nothing else.
    if (!open || !panel || !picks.length || !commits.length) return;

    collapse();
    open.hidden = false;

    open.addEventListener('click', function () {
      if (panel.hidden) {
        panel.hidden = false;
        open.setAttribute('aria-expanded', 'true');
        picks[0].focus();
      } else {
        // Closing the panel discards the choice. Leaving a cadence selected
        // under a collapsed panel is precisely the hidden state a15 ① is
        // about — the customer would not be looking at what they picked.
        collapse();
      }
    });

    picks.forEach(function (pick) {
      pick.addEventListener('click', function () {
        var id = pick.getAttribute('data-purchase-pick');
        picks.forEach(function (p) {
          p.setAttribute('aria-pressed', String(p === pick));
        });
        commits.forEach(function (c) {
          c.hidden = c.getAttribute('data-purchase-commit') !== id;
        });
      });
    });

    /**
     * ⚠ Back-navigation restores the DOM from the bfcache with hidden states
     * intact, so a customer who picked a cadence, left, and came back would
     * return to a live subscribe commit they are no longer looking at. Reset
     * it — a15 ⑦ #4 requires the one-time default to survive re-render and
     * refresh, and this is the case the browser hands back rather than
     * re-rendering.
     */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) collapse();
    });

    function collapse() {
      panel.hidden = true;
      open.setAttribute('aria-expanded', 'false');
      picks.forEach(function (p) {
        p.setAttribute('aria-pressed', 'false');
      });
      commits.forEach(function (c) {
        c.hidden = true;
      });
    }
  }
})();
